exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4cdc3e50] .required label.v-label.theme--light:before {\n  content: \"*\";\n  color: red;\n}", ""]);

// exports
